import { cn } from '../..';

export const SelectableCard = ({
  isSelected,
  className,
  isNextCardSelected,
  ...props
}: {
  children: React.ReactNode;
  isSelected: boolean;
  onClick: () => void;
  isNextCardSelected?: boolean;
} & React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      '@SelectableCard',
      'flex cursor-pointer flex-col gap-1 border border-neutral/10 border-x-transparent border-t-transparent p-2.5 transition-all last:border-b-transparent',
      'hover:rounded-md hover:border hover:border-transparent hover:bg-neutral/3',
      isSelected &&
        'rounded-md border border-neutral/5 bg-neutral/5 hover:border-neutral/5 hover:bg-neutral/5',
      isNextCardSelected && 'border-b-transparent',
      className,
    )}
    {...props}
  />
);
